interface DropOffEntity {
  id: number;
  tanggal: Date;
  shift: number;
  vendor: string;
  lokasi_drop_off: string;
  id_requestor: number;
  requestor: string;
  penerima?: string;
  porsi_reguler: number;
  porsi_vegetarian: number;
  status: string;
}

interface AddDropOffEntity {
  tanggal?: Date;
  shift?: 1 | 2 | 3 | 0;
  id_vendor_porsi?: number;
  outlet?: string;
  lokasi_drop_off?: string;
  id_requestor?: number;
  requestor?: string;
  porsi_reguler?: number;
  porsi_vegetarian?: number;
  porsi_reguler_available?: number;
  porsi_vegetarian_available?: number;
  status?: string;
}

interface AddFileDropOffEntity {
  id_vendor_dropoff?: number;
  penerima?: string;
  file?: File;
}

enum SPECIAL_DROPOFF_KARYAWAN_ID {
  DROPOFF_SISA = -1
}

export { SPECIAL_DROPOFF_KARYAWAN_ID }
export type { DropOffEntity, AddDropOffEntity, AddFileDropOffEntity };